import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { applicationFormUrl } from '../../data/contact';
interface CtaButtonProps {
  children?: React.ReactNode;
  href?: string;
  variant?: 'primary' | 'light';
  size?: 'md' | 'lg';
  className?: string;
}
export function CtaButton({
  children = 'Quiero mi diagnóstico gratis',
  href = applicationFormUrl,
  variant = 'primary',
  size = 'lg',
  className = ''
}: CtaButtonProps) {
  const colors = variant === 'primary' ? 'bg-brand text-white hover:bg-neon hover:shadow-[0_0_32px_rgba(255,26,26,0.35)] focus-visible:outline-neon' : 'bg-white text-ink hover:bg-white/90 focus-visible:outline-white';
  const sizing = size === 'lg' ? 'px-7 py-4 text-lg sm:px-8 sm:text-xl' : 'px-5 py-3 text-base';
  return <a href={href} {...href.startsWith('http') ? {
    target: '_blank',
    rel: 'noopener noreferrer'
  } : {}} className={`group inline-flex items-center justify-center gap-3 rounded-md font-display font-bold uppercase tracking-wide transition-[background-color,box-shadow,transform] duration-150 ease-out active:scale-[0.98] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 ${colors} ${sizing} ${className}`} data-id="element-281" data-mp="136jxucfblc5h">
      <span className="text-balance text-center" data-id="element-282" data-mp="2qgzjj18ci8o3">{children}</span>
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-283" data-mp="2lhws4jlag0yl" />
    </a>;
}